import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PriorityButtonGroup from './PriorityButtonGroup';

const styles = theme => ({
  root: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > label': {
      marginBottom: theme.spacing(2),
      color: theme.palette.facet.primaryGray,
      flex: '0',
      ...theme.typography.body1,
    },
    '& > div': {
      paddingLeft: 0,
    },
    '& > div > button': {
      width: '100px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    root: {
      '& > label': {
        marginBottom: theme.spacing(1),
      },
      '& > div': {
        marginBottom: theme.spacing(2),
      },
    },
  },
});

const GoalFormPriorityButtonGroup = ({ className, classes, ...rest }) => {
  const colorMap = {
    low: 'accentBlue',
    medium: 'accentBlue2',
    high: 'primary',
  };
  return (
    <PriorityButtonGroup
      colorMap={colorMap}
      onlyFillSelected={false}
      variant="contained"
      className={classNames(classes.root, className)}
      {...rest}
    />
  );
};

export default withStyles(styles)(GoalFormPriorityButtonGroup);
